/**
 * Formats duration in minutes to a human-readable string
 * < 1 hour: "30 mins"
 * >= 1 hour and <= 8 hours: "1 hour 30 mins"
 * > 8 hours: "2 days 3 hours 30 mins"
 */
export function formatMeetingDuration(durationMins: number): string {
  if (durationMins < 60) {
    return `${durationMins} mins`;
  }

  // For durations > 8 hours (480 mins), show days
  if (durationMins > 480) {
    const days = Math.floor(durationMins / 1440);
    const remainingMins = durationMins % 1440;
    const hours = Math.floor(remainingMins / 60);
    const mins = remainingMins % 60;

    const parts: string[] = [];
    if (days > 0) {
      parts.push(days === 1 ? "1 day" : `${days} days`);
    }
    if (hours > 0) {
      parts.push(hours === 1 ? "1 hour" : `${hours} hours`);
    }
    if (mins > 0) {
      parts.push(`${mins} mins`);
    }

    return parts.join(" ");
  }

  // For durations >= 1 hour and <= 8 hours
  const hours = Math.floor(durationMins / 60);
  const mins = durationMins % 60;

  const parts: string[] = [];
  parts.push(hours === 1 ? "1 hour" : `${hours} hours`);
  if (mins > 0) {
    parts.push(`${mins} mins`);
  }

  return parts.join(" ");
}
